export function clearClinicalRuntimeState(vm) {
  vm.$store.commit('SET_CLINICAL_STATE_LOCK', true)
  vm.$store.commit('examinations/clearLicenseRestrictedState')
  vm.$store.commit('patients/clearLicenseRestrictedState')
  vm.$store.commit('report/clearLicenseRestrictedState')
  vm.dialog = false
  vm.editDialog = false
  vm.transferLoading = false
  vm.notifyDialog = false
  vm.newAccNo = ''
  vm.transferResultMessage = ''
  vm.selectedExamination = ''
  vm.infoList = []
  vm.examInfo = { medicalRecord: '', examinationRecord: '', hospitalCode: '' }
}
